var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlinked = function SvgUnlinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__a)",
    d: "M49.564 52.204h18.334c6.673 0 12.102-5.43 12.102-12.102S74.571 28 67.898 28H49.564c-6.673 0-12.102 5.429-12.102 12.102s5.429 12.102 12.102 12.102m18.334-18.296a6.2 6.2 0 0 1 6.194 6.194 6.2 6.2 0 0 1-6.194 6.194H49.564a6.2 6.2 0 0 1-6.194-6.194 6.2 6.2 0 0 1 6.194-6.194z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__b)",
    d: "M12.096 68.885c3.099 0 6.198-1.18 8.557-3.539l12.965-12.964a12.02 12.02 0 0 0 3.544-8.557c0-3.233-1.259-6.272-3.544-8.558a2.954 2.954 0 1 0-4.178 4.178 6.15 6.15 0 0 1 1.814 4.38c0 1.654-.644 3.21-1.814 4.38L16.476 61.169a6.15 6.15 0 0 1-4.38 1.814 6.15 6.15 0 0 1-4.38-1.814 6.2 6.2 0 0 1 0-8.76l12.965-12.964a2.954 2.954 0 1 0-4.178-4.177L3.54 48.232c-4.719 4.718-4.719 12.396 0 17.114a12.07 12.07 0 0 0 8.557 3.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__c)",
    d: "M27.762 44.113h25.07a2.954 2.954 0 0 0 0-5.908h-25.07a2.954 2.954 0 1 0 0 5.908"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__d)",
    d: "M39.11 14.837a2.954 2.954 0 0 1 5.57 1.97l-3.195 9.034a2.95 2.95 0 0 1-3.77 1.8 2.954 2.954 0 0 1-1.8-3.77z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__e)",
    d: "M12.147 19.868a2.954 2.954 0 0 1 4.177.034l6.721 6.83a2.954 2.954 0 0 1-4.21 4.143l-6.722-6.83a2.954 2.954 0 0 1 .034-4.177"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__f)",
    d: "M26.342 11.184a2.954 2.954 0 0 1 3.524 2.243l2.838 12.76a2.954 2.954 0 1 1-5.768 1.283L24.1 14.709a2.954 2.954 0 0 1 2.243-3.525"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__g)",
    d: "M79.048 65.98 67.39 46.165c-.962-1.635-2.646-2.453-4.33-2.453l-6.27 14.815 6.27 14.815h11.66c3.848 0 6.254-4.09 4.33-7.36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#unlinked_svg__h)",
    d: "M58.727 46.164 47.068 65.981c-1.924 3.27.481 7.36 4.33 7.36h11.66V43.71c-1.684 0-3.368.818-4.33 2.453"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3.704,
    d: "M63.055 51.117v10.185M63.055 66.852v1.851"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.5265 21.92027 -16.15494 32.8154 31.28 29.576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CFE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(38.89946 31.22972 -28.35488 35.31858 -5.401 36.647)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CFE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.15702 5.35076 -1.95397 9.5519 27.165 38.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(54.852 3.876 40.087)scale(16.5523 14.4913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D5EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(47.25 -16.576 23.9)scale(15.71 14.5641)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "unlinked_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.1554 16.90876 -13.16731 7.12955 22.757 12.329)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACB9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CFE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlinked_svg__g",
    x1: 68.257,
    x2: 68.257,
    y1: 41.423,
    y2: 83.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlinked_svg__h",
    x1: 54.724,
    x2: 54.724,
    y1: 41.423,
    y2: 83.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgUnlinked;